import { QrReader } from '@blackbox-vision/react-qr-reader';

const QrScannerMock = () => <></>;

export default !process.env.JEST_WORKER_ID ? QrReader : QrScannerMock;
